import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button } from '@outdoor-voices/ui';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import { CustomItem, ProductItem, UGCItem } from './Items';
import { isTargetBlank } from './utils';
import { Wrapper } from '../../apps/homepage/Wrapper';
import Caro from './Carousel';
import CarouselLoading from './CarouselLoading';
import css from './Carousel.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var mapBlocks = function mapBlocks(_ref) {
  var _ref$node = _ref.node,
      cta = _ref$node.cta,
      id = _ref$node.id,
      image = _ref$node.image,
      subtitle = _ref$node.subtitle,
      title = _ref$node.title,
      url = _ref$node.url;
  return {
    id: id,
    children: /*#__PURE__*/_jsx(CustomItem, {
      cta: cta,
      image: image,
      subtitle: subtitle,
      title: title,
      url: url
    })
  };
};

var mapProducts = function mapProducts(_ref2) {
  var node = _ref2.node;
  var colorway = node.colorway,
      id = node.id,
      product = node.product;
  if (product === null) return;
  var assets = colorway.assets.edges,
      variant = colorway.variant;
  var absoluteUrl = product.absoluteUrl,
      colorways = product.colorways,
      itemTitle = product.title;
  var availableColors = colorways === null || colorways === void 0 ? void 0 : colorways.edgeCount;
  var shopifyId = variant.shopifyId;
  var variantParam = shopifyId ? "?variant=".concat(shopifyId) : '';
  var image = false;
  var imageHover = false;

  if (assets && assets[0]) {
    image = _objectSpread(_objectSpread({}, assets[0].node.image), {}, {
      alt: "".concat(itemTitle, " in the color ").concat(colorway.title, " - ").concat(assets[0].node.image.alt)
    });
  }

  if (assets && assets[1]) {
    imageHover = _objectSpread(_objectSpread({}, assets[1].node.image), {}, {
      alt: "".concat(itemTitle, " in the color ").concat(colorway.title, " - ").concat(assets[1].node.image.alt)
    });
  }

  var itemSubtitle = availableColors && availableColors > 1 ? "".concat(availableColors, " colors available.") : '';
  var url = "".concat(absoluteUrl).concat(variantParam);
  return {
    id: id,
    children: /*#__PURE__*/_jsx(ProductItem, {
      image: image,
      imageHover: imageHover,
      subtitle: itemSubtitle,
      title: itemTitle,
      url: url
    })
  };
};

var mapUGCs = function mapUGCs(_ref3) {
  var node = _ref3.node;
  var id = node.id,
      ugc = node.ugc;
  return {
    id: id,
    children: /*#__PURE__*/_jsx(UGCItem, _objectSpread({}, ugc))
  };
};

var carouselTypes = {
  CAROUSEL_CUSTOM: {
    edgeKey: 'blocks',
    mapItems: mapBlocks
  },
  CAROUSEL_PRODUCT: {
    edgeKey: 'carouselProducts',
    mapItems: mapProducts
  },
  CAROUSEL_UGC: {
    edgeKey: 'carouselUGCs',
    mapItems: mapUGCs
  }
};
/* eslint-disable react/destructuring-assignment */

var Carousel = function Carousel(props) {
  var componentType = props.componentType,
      title = props.title,
      cta = props.cta,
      displayBackground = props.displayBackground,
      url = props.url;
  var _carouselTypes$compon = carouselTypes[componentType],
      edgeKey = _carouselTypes$compon.edgeKey,
      mapItems = _carouselTypes$compon.mapItems;
  var items = props[edgeKey].edges;

  var _useInView = useInView({
    triggerOnce: true
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      inViewRef = _useInView2[0],
      inView = _useInView2[1];

  if (!items.length) {
    return false;
  }

  var carouselItems = items.map(mapItems);
  return /*#__PURE__*/_jsx(Wrapper, {
    wrap: displayBackground,
    children: /*#__PURE__*/_jsxs("section", {
      className: css.root,
      ref: inViewRef,
      children: [title && /*#__PURE__*/_jsx("h3", {
        className: css.title,
        children: title
      }), inView && /*#__PURE__*/_jsx(Caro, {
        items: carouselItems,
        name: componentType
      }), !inView && /*#__PURE__*/_jsx(CarouselLoading, {
        item: carouselItems[0]
      }), cta && url && /*#__PURE__*/_jsx("div", {
        className: css.cta,
        children: /*#__PURE__*/_jsx(Button, {
          ariaLabel: "".concat(cta, " ").concat(cta.indexOf(title) > -1 ? '' : title !== null && title !== void 0 ? title : ''),
          big: true,
          href: url,
          targetBlank: isTargetBlank(url),
          children: cta
        })
      })]
    })
  });
};

Carousel.defaultProps = {
  blocks: {
    edges: []
  },
  carouselProducts: {
    edges: []
  }
};
Carousel.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape())
  }),
  carouselProducts: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape())
  }),
  componentType: PropTypes.string.isRequired,
  cta: PropTypes.string,
  displayBackground: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string
};
export default Carousel;